import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

/**
 * Anonymous route component that checks authentication status
 * If not authenticated, renders the child routes
 * If authenticated, redirects to the setup page
 */
const AnonymousRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // If authenticated, render the child routes; otherwise redirect to setup
  return !isAuthenticated ? <Outlet /> : <Navigate to="/landing" replace />;
};

export default AnonymousRoute;